<template>
  <div id="app">
    <el-container
      v-if="
        ![
          'template',
          'preview',
          'iframe',
          'login',
          '404',
          'reset_password',
          'verification',
          'sign_up',
        ].includes($route.name)
      "
    >
      <el-header>
        <navbar></navbar>
      </el-header>
      <el-container>
        <el-aside :style="isCollapse ? 'width: 80px' : 'width: 250px'">
          <sidebar v-if="stageType === CONSTANT.STAGE_TYPE.FRONT"></sidebar>
          <backstage-sidebar v-else-if="stageType === CONSTANT.STAGE_TYPE.BACK">
          </backstage-sidebar>
        </el-aside>
        <el-main
          style="margin: 0px auto;"
          :style="isCollapse ? 'margin-left: 80px' : 'margin-left: 250px'"
        >
          <transition name="page" mode="out-in">
            <router-view :key="$route.path"></router-view>
          </transition>
        </el-main>
      </el-container>
      <el-footer>
        <p style="font-size:13px;">
          Terms of Use |
          <a
            class="pink"
            href="https://www.ucfunnel.com/privacy-policy"
            target="_blank"
            >Privacy Policy</a
          >
          |
          <a
            class="pink"
            href="https://www.ucfunnel.com/content-guidelines"
            target="_blank"
          >
            Content Guidelines</a
          >
        </p>
        <p style="font-size:12px;">
          © 2019 Powered by
          <a class="pink" href="https://www.ucfunnel.com" target="_blank"
            >ucfunnel</a
          >
          . All Rights Reserved.
        </p>
      </el-footer>
    </el-container>

    <transition name="page" mode="out-in" v-else>
      <router-view :key="$route.path"></router-view>
    </transition>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Navbar from "./components/common/layouts/navbar";
import Sidebar from "./components/common/layouts/sidebar";
import BackstageSidebar from "./backstage/components/layout/sidebar";
export default {
  components: {
    navbar: Navbar,
    sidebar: Sidebar,
    "backstage-sidebar": BackstageSidebar,
  },
  computed: {
    ...mapState({
      isCollapse: (state) => state.isSidebarCollapse,
      stageType: (state) => state.stageType,
    }),
  },
  created() {
    if (window.location.origin === `${config.dashboard_backstage_domain}`) {
      this.setStageTypeToBackstage();
    }
  },
  methods: {
    ...mapMutations(["setStageTypeToBackstage"]),
  },
};
</script>
